module.exports = __webpack_public_path__ + "assets/download.5f7aaf30.svg";